import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-custom-toastr',
  standalone: false,
  templateUrl: './custom-toastr.component.html',
  styleUrls: ['./custom-toastr.component.scss'],
  animations: [
    trigger('toastrAnim', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('250ms cubic-bezier(.4,0,.2,1)', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms cubic-bezier(.4,0,.2,1)', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class CustomToastrComponent {
  @Input() status: 'success' | 'error' | 'info' | 'warning' = 'success';
  @Input() message: string = '';
  @Input() showClose: boolean = true;

  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
